import type { SchemaBuilderFieldTypePickerProps } from "./schema-builder-field-type-picker.type";

import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";

import { useSchemaBuilderFieldTypePickerOptions } from "./schema-builder-field-type-picker.hook";

export const SchemaBuilderFieldTypePicker = ({
  name,
  label: customLabel,
  required,
  disabled,
  initialType,
  onTypeChange,
  showAll,
}: SchemaBuilderFieldTypePickerProps) => {
  const { t } = useTranslation();
  const label = customLabel ?? t("schema:property:fieldType");
  const options = useSchemaBuilderFieldTypePickerOptions({ showAll });

  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialType}
      required={required}
    >
      <Select options={options} disabled={disabled} onChange={onTypeChange} />
    </Form.Item>
  );
};
